<template lang="html">
    <div class="map-style-switcher" :class="{ showing: value }">

        <div
            id="map-style-switcher-button"
            class="mapboxgl-ctrl mapboxgl-ctrl-group style-switcher-control"
            @click="show(!value)">
            <v-tooltip right>
                <button type="button" slot="activator">
                    <v-icon class="mbgl-color">map</v-icon>
                </button>
                <span>Change map style</span>
            </v-tooltip>
        </div>

        <div
            class="style-selection mapboxgl-ctrl mapboxgl-ctrl-group mbgl-color"
            v-if="value">
            <v-list dense light subheader>
                <v-subheader><span class="selection-subhead mbgl-color">Map style</span></v-subheader>
                <v-list-tile
                    class="list-item"
                    avatar
                    v-for="style in styles"
                    :key="style.value"
                    @click="currentStyle = style">

                    <input
                    :id="style.value"
                    type="radio"
                    :value="style"
                    v-model="currentStyle">

                    <v-list-tile-content>
                        <v-list-tile-title v-text="style.name"></v-list-tile-title>
                    </v-list-tile-content>
                </v-list-tile>
            </v-list>
        </div>
    </div>
</template>

<script>
import mapMixin from '@/mixins/map';

export default {
    name: 'map-style-switcher',
    mixins: [mapMixin],
    props: {
        value: Boolean,
    },
    data() {
        return {
            currentStyle: {
                name: 'Default',
                value: 'default',
                url: this.$cfg.mapboxgl.baseStyle,
            },
            // basic mapbox styles
            styles: [
                {
                    name: 'Default',
                    value: 'default',
                    url: this.$cfg.mapboxgl.baseStyle,
                },
                {
                    name: 'Basic',
                    value: 'basic',
                    url: 'mapbox://styles/mapbox/basic-v9',
                },
                {
                    name: 'Bright',
                    value: 'bright',
                    url: 'mapbox://styles/mapbox/bright-v9',
                },
                {
                    name: 'Light',
                    value: 'light',
                    url: 'mapbox://styles/mapbox/light-v9',
                },
                {
                    name: 'Dark',
                    value: 'dark',
                    url: 'mapbox://styles/mapbox/dark-v9',
                },
                {
                    name: 'Satellite',
                    value: 'satellite',
                    url: 'mapbox://styles/mapbox/satellite-v9',
                },
            ],
        };
    },
    methods: {
        /**
         * change visible state of the style selector
         * hides by default
         * @param  {Boolean} [on=false] true for visible
         */
        show(on = false) {
            this.$emit('input', on);
        },
    },
    watch: {
        currentStyle() {
            // don't try to change the style if the map isn't loaded
            if (this.map === null) {
                return;
            }

            // hide the selection menu
            this.show(false);

            // set map style URL
            this.map.setStyle(this.currentStyle.url);

            // emit an event, notify the parent page to re-add map layers, etc.
            this.map.once('style.load', () => {
                this.$emit('switchedStyle', this.currentStyle.url);
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.map-style-switcher {
    > div {
        position: absolute;
        top: 120px;
        left: 10px;
    }

    .mbgl-color {
        color: #333;
    }

    .style-switcher-control {
        button {
            height: 30px;
            width: 30px;
        }
    }

    .style-selection {
        margin-left: -4px;
        margin-top: -4px;

        .selection-subhead {
            margin-left: 30px;
        }

        input {
            margin-right: .5rem;
        }
    }

    &.showing {
        z-index: 2;
        .style-switcher-control {
            z-index: 3;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/MapStyleSwitcher.vue